import moment from 'moment/moment';
import DTO from './DTO';

class TariffDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: {},
        labelKey: 'tariff.id',
      },
      {
        name: 'start_time',
        type: String,
        validators: {},
        labelKey: 'tariff.start_time',
      },
      {
        name: 'end_time',
        type: String,
        validators: {},
        labelKey: 'tariff.end_time',
      },
      {
        name: 'name',
        type: String,
        validators: {},
        labelKey: 'tariff.name',
      },
      {
        name: 'vehicle_type',
        type: String,
        validators: {},
        labelKey: 'tariff.vehicle_type',
      },
      {
        name: 'time_unit',
        type: String,
        validators: {},
        labelKey: 'tariff.time_unit',
      },
      {
        name: 'free_duration',
        type: Number,
        validators: {},
        labelKey: 'tariff.free_duration',
      },
      {
        name: 'day_types',
        type: Array,
        validators: {},
        labelKey: 'tariff.day_types',
      },
      {
        name: 'description',
        type: String,
        validators: {},
        labelKey: 'tariff.description',
      },
      {
        name: 'type',
        type: String,
        validators: {},
        labelKey: 'tariff.type',
      },
      {
        name: 'cost',
        type: Number,
        validators: {},
        labelKey: 'tariff.cost',
      },
      {
        name: 'is_active',
        type: Boolean,
        validators: {},
        labelKey: 'tariff.is_active',
      },
      {
        name: 'created_at',
        type: moment,
        validators: [],
        labelKey: 'created_at',
      },
      {
        name: 'updated_at',
        type: moment,
        validators: [],
        labelKey: 'updated_at',
      },
    ];
    super(attributes, params, isValidInit);
  }
}

export default TariffDTO;
